import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import MenuIcon from '@material-ui/icons/Menu';
import ListItemText from '@material-ui/core/ListItemText';
import { NavLink } from 'react-router-dom';


const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: '200px',
  },
  menu :{
      fontSize: '10px',
      fontWeight : "bolder",
      padding: "2px 20px"
  },
    menuDev :{
      color: 'gray',
      top: '160px',
      fontSize: '2px',
      fontWeight : "bold",
      padding: "2px 10px"
  }
});

export default function SideMenuDrawer(){
  const classes = useStyles();
  const [state, setState] = React.useState({
    left: false,
  });

  const category1 = ['Home', 'Africa.', 'World',  'Politics','Entertainment', 'Business','Tech','Science','Health','Sports']
  const category2 = ['Arts','Books', 'Travel','JubaTimes Magzine','Real Estate']
  
  const toggleDrawer = (anchor, open) => (event) => {
   
    setState({ ...state, [anchor]: open });
  };
 
  const list = (anchor) => (
    <div className={classes.fullList}
         onClick={toggleDrawer(anchor, false)}
    >

      <List>
        {category1.map((text) => (
          <ListItem className={classes.menu} button key={text}>
            <NavLink style={{textDecoration:"none", color:"black"}} to = {`/Articles/${text.toLowerCase().replace(/[^\w\s]/gi, "")}`}> <ListItemText  primary={text} /> </NavLink> 
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {category2.map((text) => (
          <ListItem className={classes.menu} button key={text}>
            <ListItemText primary={text} />
          </ListItem>
        ))}
      </List>
      <List>
       
          <ListItem className={classes.menuDev} button >
            <NavLink style={{textDecoration:"none", color:"gray"}} to = {`https://junubai.ss`}> 
              <ListItemText  primary={"Developed by GraBit Technologies"} /> 
            </NavLink> 
          </ListItem>
    
      </List>
    </div>
  );
    return (
        <div>
          <React.Fragment key="left">
          <MenuIcon onClick={toggleDrawer('left', true)}/>
          <SwipeableDrawer
            anchor={'left'}
            open={state['left']}
            onClose={toggleDrawer('left', false)}
            onOpen={toggleDrawer('left', true)}
          >
            {list('left')}
          </SwipeableDrawer>
        </React.Fragment>
      
    </div>
  );
}
